import { CustomFields } from './custom-fields.interface';
import { DisplayMap, PropsMap, propsMapToDisplayMap } from 'utils/constants.helpers';
import moment from 'moment-mini';
import { CUSTOM_FIELD_TYPES } from 'constants/constants';

export const CUSTOM_FIELDS_TYPES: PropsMap = {
  NUMBER: { id: CUSTOM_FIELD_TYPES.NUMBER, name: 'Number' },
  STRING: { id: CUSTOM_FIELD_TYPES.STRING, name: 'String' },
  TEXTAREA: { id: CUSTOM_FIELD_TYPES.TEXTAREA, name: 'Textarea' },
  DATE: { id: CUSTOM_FIELD_TYPES.DATE, name: 'Date' },
  BOOLEAN_SELECT: { id: CUSTOM_FIELD_TYPES.BOOLEAN_SELECT, name: 'True/False' },
  ATTACHMENT: { id: CUSTOM_FIELD_TYPES.ATTACHMENT, name: 'Attachments' },
  PHONE_NUMBER: { id: CUSTOM_FIELD_TYPES.PHONE_NUMBER, name: 'Phone Number' },
  COUNTRY_SELECT: { id: CUSTOM_FIELD_TYPES.SELECT_COUNTRY, name: 'Country' },
  STATE_SELECT: { id: CUSTOM_FIELD_TYPES.SELECT_STATE, name: 'State/Province' },
};

export const CUSTOM_FIELDS_TYPES_MAP: DisplayMap = propsMapToDisplayMap(CUSTOM_FIELDS_TYPES);

export const CUSTOM_FIELDS_STATUS: PropsMap = {
  ACTIVE: { id: 1, name: 'Active' },
  INACTIVE: { id: 3, name: 'Inactive' },
};

export const CUSTOM_FIELDS_STATUS_MAP: DisplayMap = propsMapToDisplayMap(CUSTOM_FIELDS_STATUS);

export const CUSTOM_FIELDS_BOOLEAN_SELECT_OPTIONS: PropsMap = {
  YES: { id: '1', name: 'Yes' },
  NO: { id: '2', name: 'No' },
};

export const CUSTOM_FIELDS_BOOLEAN_SELECT_OPTIONS_MAP: DisplayMap = propsMapToDisplayMap(
  CUSTOM_FIELDS_BOOLEAN_SELECT_OPTIONS,
);

export const DEFAULT_CUSTOM_FIELD = {
  field_id: null,
  name: '',
  label: '',
  type_id: CUSTOM_FIELD_TYPES.TEXTAREA,
  group_id: null,
  is_required: false,
  is_encrypted: false,
  professional_read_only: false,
  default_value: '',
  status_id: CUSTOM_FIELDS_STATUS.ACTIVE.id,
  is_mapped: false,
  use_in_profile: false,
  use_in_list: false,
  is_encrypting_enabled: true,
};

export const isCustomItemGroup = (item: CustomFields.Item): item is CustomFields.Group => 'fields' in item;

export const trackCustomFieldByFn = (_, item: CustomFields.Item): number => {
  const groupUniqueness = 1000000;
  return isCustomItemGroup(item) ? item.group_id + groupUniqueness : item.field_id;
};

export const getBooleanFieldName = (type: string): string => CUSTOM_FIELDS_BOOLEAN_SELECT_OPTIONS_MAP[type];

export const getDateFieldName = (value: string): string => {
  if (value) {
    const date = moment(value);
    if (date.isValid()) {
      return date.format('YYYY-MM-DD');
    }
  }
  return value;
};
